import {get} from 'lodash';
import {FC} from 'react';
import {useSetRecoilState} from 'recoil';
import {ArchiveButton} from '../../../../components/ArchiveButton';
import {ContractDto} from '../../../../global/api';
import {
  useGetContractsQueryRefresh,
  usePostContractsArchiveMutation,
  usePostContractsFindByIdsQuerySuspenseRefresh,
} from '../../../../global/services/contracts';
import {serviceRequestsQueryTrigger} from '../../../../store/service-requests/atoms';

interface Props {
  contract: ContractDto;
  disabled?: boolean;
}

export const ContractGeneralInfoArchiveManager: FC<Props> = ({contract, disabled = false}) => {
  const triggerQuery = useSetRecoilState(serviceRequestsQueryTrigger);
  const {mutate} = usePostContractsArchiveMutation();
  const refreshFn = usePostContractsFindByIdsQuerySuspenseRefresh();
  const refreshFnGetContracts = useGetContractsQueryRefresh();
  const isArchived = get(contract, 'archived', false);

  const afterArchiveMutation = () => {
    refreshFn();
    refreshFnGetContracts();
    triggerQuery((p) => p + 1);
  };

  const handleArchive = async () => {
    if (!contract.id) return;
    await mutate([{contractId: contract.id, isArchived: !isArchived}], afterArchiveMutation);
  };

  return <ArchiveButton archived={isArchived} onClick={handleArchive} disabled={disabled} />;
};
